export default "__VITE_ASSET__Ht0TR9CG__"